import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=00f2531e&scoped=true&"
import script from "./CouponForm.vue?vue&type=script&lang=ts&"
export * from "./CouponForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2531e",
  null
  
)

export default component.exports